import React, { useState } from 'react';
import { MapPin, ExternalLink, Navigation } from 'lucide-react';
import { Contract } from '../../../types/contract';
import {
  getGoogleMapsSearchUrl,
  getGoogleMapsDirectionsUrl,
  getGoogleMapsEmbedUrl,
  MAPS_CONFIG
} from '../../../config/maps';
import { ComponentHeader } from './ComponentHeader';

interface LocationCardProps {
  contract: Contract;
}

export const LocationCard: React.FC<LocationCardProps> = ({ contract }) => {
  const [showMap, setShowMap] = useState(true);

  const getAddress = () => {
    const parts = [
      contract.enderecoFesta,
      contract.bairro,
      contract.cidade
    ].filter(Boolean);
    
    return parts.join(', ');
  };

  const address = getAddress();

  return (
    <div className="bg-white shadow-lg border border-slate-200 rounded-lg overflow-hidden">
      <ComponentHeader
        title="Localização"
        subtitle="Endereço do evento"
        icon={MapPin}
      />
      
      <div className="p-3">
        <div className="space-y-3">
          {/* Endereço */}
          <div className="space-y-2 text-xs">
            <div className="flex justify-between items-center">
              <span className="text-slate-500">Endereço:</span>
              <span className="font-semibold text-slate-800 text-xs">
                {contract.enderecoFesta || 'N/A'}
              </span>
            </div>
            
            <div className="flex justify-between items-center">
              <span className="text-slate-500">Bairro:</span>
              <span className="font-semibold text-slate-800 text-xs">
                {contract.bairro || 'N/A'}
              </span>
            </div>
            
            <div className="flex justify-between items-center">
              <span className="text-slate-500">Cidade:</span>
              <span className="font-semibold text-slate-800 text-xs">
                {contract.cidade || 'N/A'}
              </span>
            </div>
          </div>

          {/* Mapa do Google Maps */}
          {address && MAPS_CONFIG.GOOGLE_MAPS_API_KEY ? (
            <div className="space-y-2">
              <div className="relative">
                <iframe
                  title="Localização do evento"
                  src={getGoogleMapsEmbedUrl(address)}
                  width="100%"
                  height="200"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  className="rounded-lg shadow-sm"
                />
              </div>
              
              {/* Botões de ação */}
              <div className="flex gap-2">
                <a
                  href={getGoogleMapsSearchUrl(address)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors text-xs font-medium"
                >
                  <ExternalLink className="w-3 h-3" />
                  Abrir Maps
                </a>
                <a
                  href={getGoogleMapsDirectionsUrl(address)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 flex items-center justify-center gap-2 px-3 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors text-xs font-medium"
                >
                  <Navigation className="w-3 h-3" />
                  Navegar
                </a>
              </div>
            </div>
          ) : address ? (
            <div className="text-center py-4 text-slate-400 bg-slate-50 rounded-lg">
              <MapPin className="w-8 h-8 mx-auto mb-2 opacity-50" />
              <p className="text-xs">Chave da API do Google Maps não configurada</p>
              <p className="text-xs">Configure REACT_APP_GOOGLE_MAPS_API_KEY</p>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
